import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-address-advt-labels',
  templateUrl: './address-advt-labels.component.html',
  styleUrl: './address-advt-labels.component.scss'
})
export class AddressAdvtLabelsComponent {

  Address: any;
  flatAddresses: any[] = [];  // Add this property
  pincode: any;
  name: any;
  issuenamenew: any;
  cust_name: any;
  issuedatepp: any;
  val: any;
  advt_name: any;
  rep_name: any;
  off_rep_name: any;
  issue_category: any;
  issue_dates: any;
  issue_date: string;
  issue_name: any;
  today: Date;
  district: any;
  taluka: any;
  modetype: any;
  start_date: any;
  end_date: any;
  prantname: any;
  country: any;
  state: any;
  duration: any;
  currentDate = new Date();
  issueDates: any;
  advtType:any;

  constructor(
    private dialogRef: MatDialogRef<AddressAdvtLabelsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService,
    private cdr: ChangeDetectorRef,
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {
    debugger;
    this.issuenamenew = this.data['newissuedatepp'];
    this.cust_name = this.data['cust_name'];
    this.issuedatepp = this.data['issuedatepp'];
    this.start_date = this.data['start_date'];
    this.end_date = this.data['end_date'];
    this.val = this.data['val'];
    this.district = this.data['district'];
    this.country = this.data['country'];
    this.state = this.data['state'];
    this.taluka = this.data['taluka'];
    this.advtType = this.data['advtType'];
    this.rep_name = this.data['repname'];
    this.issueDates = this.data['issueDates'];

    this.advt_name = this.data['advt_name'] || '';
    this.rep_name = this.data['repname'] || '';
    this.off_rep_name = this.data['offRepName'] || '';

    this.issue_date = this.data['issue_date'] + '';
    if (this.issue_date.includes(',')) {
      [this.issue_date, this.issue_name] = this.issue_date.split(',');
    }
    this.today = new Date();

    this.getAllAddlables(this.val);
  }

  getAllAddlables(val: any) {
    const req = {
      'value': val,
      'issue_name': this.issuenamenew,
      'issue_date': this.issueDates,
      'start_date': this.start_date,
      'end_date': this.end_date,
      'advt_name': this.advt_name,
      'rep_name': this.rep_name,
      'off_rep_name': this.off_rep_name,
      'country': this.country,
      'state': this.state,
      'taluka': this.taluka,
      'district': this.district,
      'advttype':this.advtType,
    }

    console.log(req, "new all address");

    this.service.getAllAddlables(req).subscribe(
      (data: any) => {
        console.log("pending add=", data);
        this.Address = data;

        // Flatten the Address array after receiving data
        this.flatAddresses = this.Address.flat();
        console.log("Flattened addresses:", this.flatAddresses);
      },
      (error) => {
        console.error("Error fetching addresses:", error);
      }
    );

    console.log("req 2 for add", req);
  }


  prepareAddressPages(flatData: any[]) {
    const pages: any[][] = [];

    for (let i = 0; i < flatData.length; i += 18) {
      pages.push(flatData.slice(i, i + 18));
    }

    this.Address = pages;
  }

//   print() {
//     const originalTitle = document.title;
//     document.title = 'पत्ता यादी';

//     const style = document.createElement('style');
//     style.id = 'print-styles';
//     style.innerHTML = `
// @media print {

//   @page {
//     size: A4;
//     margin: 12mm;
//   }

//   body {
//     margin: 0;
//     padding: 0;
//   }

//   .noPrint {
//     display: none !important;
//   }

//   /* MAIN PRINT AREA */
//   #print-section {
//     overflow: hidden;
//   }

//   /* FLEX GRID */
//   .row {
//     display: flex;
//     flex-wrap: wrap;
//   }

//   /* EACH ADDRESS BLOCK */
  
//   .col {
//     flex: 0 0 33.33%;
//     padding: 8px;
//     box-sizing: border-box;
//     page-break-inside: avoid;
//     overflow: visible;   /* 🔴 ALLOW FULL TEXT */
//   }

//   /* Force new page after 18 addresses */
//   .col:nth-child(18n) {
//     page-break-after: always;
//   }

//   .col:last-child {
//     page-break-after: auto;
//   }

// }
// `;


//     document.head.appendChild(style);

//     setTimeout(() => {
//       const printTrigger = document.getElementById('print-button');
//       if (printTrigger) (printTrigger as HTMLElement).click();

//       // Cleanup after printing
//       setTimeout(() => {
//         document.title = originalTitle;
//         const styleElement = document.getElementById('print-styles');
//         if (styleElement) {
//           document.head.removeChild(styleElement);
//         }
//       }, 1000);
//     }, 500);
//   }


print() {
  const originalTitle = document.title;
  document.title = 'पत्ता यादी';

  const style = document.createElement('style');
  style.id = 'print-styles';
  style.innerHTML = `
@media print {

  @page {
    size: A4;
    margin: 12mm;
  }

  body {
    margin: 0;
    padding: 0;
    font-size: 15px;   
    max-width:25ch;
    
  }

  .noPrint {
    display: none !important;
  }

  /* MAIN PRINT AREA */
  #print-section {
    overflow: hidden;
  }

  /* FLEX GRID */
  .row {
    display: flex;
    flex-wrap: wrap;
    row-gap: 46px;   /* ✅ INCREASE SPACE BETWEEN ROWS */
    margin-left: 12px;
    margin-top: -22px;
    
  }

  /* EACH ADDRESS BLOCK */
  .col {
    flex: 0 0 33.33%;
    padding: 8px;
    box-sizing: border-box;
    page-break-inside: avoid;
    overflow: visible;
  }

  /* Force new page after 18 addresses */
  .col:nth-child(18n) {
    page-break-after: always;
  }

  .col:last-child {
    page-break-after: auto;
  }

}
`;

  document.head.appendChild(style);

  setTimeout(() => {
    const printTrigger = document.getElementById('print-button');
    if (printTrigger) (printTrigger as HTMLElement).click();

    // Cleanup after printing
    setTimeout(() => {
      document.title = originalTitle;
      const styleElement = document.getElementById('print-styles');
      if (styleElement) {
        document.head.removeChild(styleElement);
      }
    }, 1000);
  }, 500);
}


  exportexcel(fileName: string): void {
    const data: any[] = [];

    this.Address.forEach(group => {
      group.forEach(d => {
        data.push({
          Name: d.name,
          Address: `${d.address}, ${d.taluka}, ${d.district} - ${d.pincode}, ${d.state}`,
          Mobile: d.mobile
        });
      });
    });

    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, `${fileName}.xlsx`);
  }
}